export default __webpack_public_path__ + "static/media/HDTX_General Riwayat Hidup Calon Anggota Direksi PT PIR Tbk.c67640bf.pdf";